import React from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../authConfig";
import { IPublicClientApplication } from "@azure/msal-browser";
import { BsPerson } from "react-icons/bs";

function handleLogin(instance: IPublicClientApplication) {
  instance.loginRedirect(loginRequest).catch((e) => {
    console.error(e);
  });
}

/**
 * Renders a button which, when selected, will redirect the page to the login prompt
 */
export const SignInButton = () => {
  const { instance } = useMsal();

  return (
    <div className="menuBarButton" onClick={() => handleLogin(instance)}>
      <BsPerson />
    </div>
  );
};
